
import {Component, Prop, Vue} from "vue-property-decorator";
import {IHome} from "@/modules/Home/interfaces/home.interface";
import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

  @Component({})
  export default class HomePrivateAccess extends Vue {
    @Prop() homeData: IHome.IData;

    displayBlock = true;
    hideBlockStorageKey = 'homePage_hidePrivateAccess'

    created() {
      let displayFromStorage = true;
      if (cookieBannerHelper.cookieConfig.optional) {
        let storageValue = localStorage.getItem(this.hideBlockStorageKey);
        displayFromStorage = !storageValue;
      }
      this.displayBlock = Boolean(this.homeData.requestAccessFlag) && displayFromStorage;
    }

    async openGetAccessPopup() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'home', dialogName: 'getAccess', });
    }

    hideBanner() {
      localStorage.setItem(this.hideBlockStorageKey, 'true');
      this.displayBlock = false;
    }
  }
